<template>
  <VCard
    flat
    class="d-flex flex-column justify-end align-center grey lighten-4 fill-height pt-2 pt-lg-3 pb-2 pb-lg-2 px-2"
    width="100%"
  >
    <img
      src="../../assets/img/interview/mic.svg"
    >
    <span class="body-1 text-center my-2">
      {{ $t('candidateNotPassed') }}
      <br>
      {{ $t('onlineInterview') }}
    </span>
    <CandidateInterviewCopyLink :link="candidate.inviteLink" />
  </VCard>
</template>

<script>
import CandidateInterviewCopyLink from '@/components/Candidate/CandidateInterviewCopyLink';

export default {
  name: 'CandidateInterviewVirtualBlank',
  components: { CandidateInterviewCopyLink },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.button-height {
  height: 40px;
}
</style>

<i18n locale="en" lang="yaml">
  candidateNotPassed: The candidate has not completed
  onlineInterview: online interview
  sendInvitation: Send invitation by e-mail
</i18n>

<i18n locale="ru" lang="yaml">
  candidateNotPassed: Кандидат пока не прошёл
  onlineInterview: онлайн-интервью
  sendInvitation: Отправить приглашение на почту
</i18n>
